var Scale = /** @class */ (function () {
    function Scale() {
        this.id = null;
        this.name = "";
        this.instructions = "";
        this.answer_start_value = 1;
        this.display_order = 1;
        this.ranges = [];
        this.isDeleted = false;
        this.multiplier = 1;
        this.negativeToPositiveRanges = false;
        this._subScales = {};
        this._type = "Sum";
        this._gradingData = {};
        this._includeInReports = true;
        this._rollUpSubScaleQuestions = false;
    }
    Object.defineProperty(Scale.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (v) {
            this._type = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "gradingData", {
        get: function () {
            return this._gradingData;
        },
        set: function (v) {
            this._gradingData = v;
        },
        enumerable: true,
        configurable: true
    });
    Scale.prototype.hasSubScales = function () {
        return this.getSubScaleIds().length > 0;
    };
    Scale.prototype.getSubScaleIds = function () {
        return Object.keys(this._subScales);
    };
    Scale.prototype.addSubScale = function (scale) {
        if (!scale) {
            throw new Error("scale object cannot be null");
        }
        if (!scale.id) {
            throw new Error("scale object must have an id");
        }
        this._subScales[scale.id] = scale;
    };
    Scale.prototype.removeSubScale = function (scale) {
        if (!scale) {
            throw new Error("scale object cannot be null");
        }
        if (!scale.id) {
            throw new Error("scale object must have an id");
        }
        if (!this._subScales[scale.id]) {
            throw new Error("Subscale " + scale.id + " not found to be removed inside scale " + this.id);
        }
        delete this._subScales[scale.id];
    };
    Scale.prototype.hasSubScale = function (scale) {
        if (!scale) {
            throw new Error("scale object cannot be null");
        }
        if (!scale.id) {
            throw new Error("scale object must have an id");
        }
        return this._subScales[scale.id] !== undefined && this._subScales[scale.id] !== null;
    };
    Scale.prototype.getAvailableSubScales = function (potentialScales) {
        var _this = this;
        var availableScales = new Map();
        potentialScales = potentialScales.filter(function (s) { return s.id != _this.id; }); // filter out ourselves.
        // first init everything as true
        potentialScales.forEach(function (ps) {
            availableScales.set(ps, true);
        });
        potentialScales.forEach(function (ps) {
            // turn off all scales reachable by current sub scales.
            if (_this._subScales[ps.id]) {
                availableScales.set(ps, false);
                // now set all the sub to be false
                // TODO: stephen we still working on the reachability aspect of this but we'll punt on this for now.
                // this.getConnectedSubScales(ps, 0).forEach(s => availableScales.set(s, false));
            }
            // if we are a sub scale of the potential scale we need to skip it...
            if (ps.hasSubScale(_this)) {
                availableScales.set(ps, false);
            }
        });
        return availableScales;
    };
    Scale.prototype.getConnectedSubScales = function (scale, depth) {
        var uniqueScales = {};
        if (!scale.SubScales) {
            return [];
        }
        if (depth > 50) {
            throw new Error("Exceeded scale depth limit on getConnectedSubScales()  scale depth should not exceed count of 50");
        }
        for (var id in scale.SubScales) {
            if (scale.SubScales.hasOwnProperty(id)) {
                this.getConnectedSubScales(scale.SubScales[id], depth + 1).forEach(function (ss) { return uniqueScales[ss.id] = ss; });
            }
        }
        return Object.keys(uniqueScales).map(function (id) { return uniqueScales[id]; });
    };
    Object.defineProperty(Scale.prototype, "SubScales", {
        get: function () {
            return this._subScales;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "negativeToPositiveRanges", {
        get: function () {
            return this._negativeToPositiveRanges;
        },
        set: function (value) {
            this._negativeToPositiveRanges = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "multiplier", {
        get: function () {
            return this._multiplier;
        },
        set: function (v) {
            this._multiplier = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "isDeleted", {
        get: function () {
            return this._deleted;
        },
        set: function (v) {
            this._deleted = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "display_order", {
        get: function () {
            return this._display_order;
        },
        set: function (order) {
            this._display_order = order;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (v) {
            this._name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "instructions", {
        get: function () {
            return this._instructions;
        },
        set: function (v) {
            this._instructions = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "answer_start_value", {
        get: function () {
            return this._answer_start_value;
        },
        set: function (v) {
            this._answer_start_value = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "ranges", {
        get: function () {
            return this._ranges;
        },
        set: function (v) {
            this._ranges = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "descriptionClient", {
        get: function () {
            return this._descriptionClient;
        },
        set: function (value) {
            this._descriptionClient = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "descriptionTherapist", {
        get: function () {
            return this._descriptionTherapist;
        },
        set: function (value) {
            this._descriptionTherapist = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "includeInReports", {
        get: function () {
            return this._includeInReports;
        },
        set: function (value) {
            this._includeInReports = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "rollUpSubScales", {
        get: function () {
            return this._rollUpSubScaleQuestions;
        },
        set: function (value) {
            this._rollUpSubScaleQuestions = value;
        },
        enumerable: true,
        configurable: true
    });
    Scale.prototype.addRange = function (range) {
        this.ranges.push(range);
    };
    Scale.prototype.removeRange = function (range) {
        var index = this.ranges.indexOf(range);
        if (index >= 0) {
            this.ranges.splice(index, 1);
        }
    };
    Scale.prototype.getMaxRange = function () {
        if (!this.ranges.length) {
            return null;
        }
        var maxRange = this.ranges[0];
        for (var index in this.ranges) {
            if (this.ranges.hasOwnProperty(index)) {
                if (this.ranges[index].rangeEnd > maxRange.rangeEnd) {
                    maxRange = this.ranges[index];
                }
            }
        }
        return maxRange;
    };
    Scale.prototype.getRangeForScore = function (score) {
        // there should only be one here...
        if (this.ranges.length) {
            var minRange = this.ranges[0];
            var maxRange = this.ranges[this.ranges.length - 1];
            // if the score is lower than the smallest range, return the first one
            if (score < minRange.rangeStart) {
                return minRange;
            }
            // if the score is greater than the largest range just return the highest range.
            if (score > maxRange.rangeEnd) {
                return maxRange;
            }
            var ranges = this.ranges.filter(function (r) { return r.rangeStart <= score && r.rangeEnd >= score; });
            if (ranges.length) {
                return ranges[0];
            }
        }
        return null;
    };
    Scale.prototype.getIntervalPercentage = function (startInterval, endInterval) {
        // we make it inclusive and start our scores off one based if the rangeStart is a 0
        var minRange = this.ranges[0].rangeStart;
        var maxRange = this.ranges[this.ranges.length - 1].rangeEnd;
        if (startInterval > 0) {
            // we are inclusive so we are adding one to the endInterval
            endInterval += 1;
        }
        var maxInterval = Math.max(maxRange - minRange, 1);
        var interval = endInterval - startInterval;
        var normalizedPercentage = Math.round((interval / maxInterval) * 100);
        return normalizedPercentage;
    };
    Scale.prototype.getMaxScore = function () {
        var range = this.getMaxRange();
        if (range) {
            return range.rangeEnd;
        }
        return 0;
    };
    Scale.prototype.getPercentageForScore = function (score) {
        if (!this.ranges.length) {
            return 0;
        }
        if (score < 0) {
            return 0;
        }
        var minRange = this.ranges[0].rangeStart;
        var maxRange = this.ranges[this.ranges.length - 1].rangeEnd;
        return this.getIntervalPercentage(minRange, score);
        // // interval needs to at least be 1
        // let interval = Math.max(maxRange - minRange, 1);
        // let scoreBottom = score - minRange;
        // let normalizedScore = Math.round(scoreBottom * 100 / interval * 100) / 100;
        // return normalizedScore;
    };
    return Scale;
}());
export { Scale };



// WEBPACK FOOTER //
// ./src/app/shared/models/scale.ts.pre-build-optimizer.js